import { useState, useMemo } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProductFileDisplayModal from "./ProductFileDisplayModal";
import { getLabel, getLanguage } from "../../tools/Dictionary";
import productFileApi from "../../api/productFileApi";
import ActionButton from "../Commons/ActionButton";
import useLog from "../../hooks/useLog";

import { MdDownload } from "react-icons/md";

import "./ProductFile.css";


const ProductFileDisplay = (props) =>
{

  //Logs
  const { logUserAction } = useLog();

  //Props
  //const IsDesktop = props.IsDesktop;
  const Data = props.Data;
  const Style = props.Style;
  const ShowDownload = props.ShowDownload || false;
  const Type = useMemo(() =>
  {
    if (props.Data && props.Data.type && props.Data.type.substring(0, 5) == "image") return "image";
    if (props.Data && props.Data.type && props.Data.type.substring(0, 5) == "video") return "video";
    if (props.Data && props.Data.type && props.Data.type == "application/pdf") return "pdf";
    else return "other"

  }, [props.Data]);

  //State
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onDownload = async () =>
  {

    try
    {

      setLoading(true);

      let response = await productFileApi.downloadProductFile(Data._id);


      logUserAction("Download Product File", { fileId: Data._id, fileName: Data.name });

      const blob = new Blob([response], {
        type: 'application/octet-stream'
      });



      let url = URL.createObjectURL(blob);

      // Create an anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = Data.name + "." + Data.format;

      // Append the anchor element to the document body
      document.body.appendChild(a);

      // Programmatically trigger a click event on the anchor element to initiate the download
      a.click();

      // Cleanup: Remove the anchor element and revoke the temporary URL
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      setLoading(false);


    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };

  const onClickLink = async() => {


    try{

      if (Type == "image" || Type == "pdf"){
        setModal(true);
      } else onDownload();
        

    }catch(err){
      
    }

  };
  

  

  if (!Data) return null;

  return (
    <div className="productfile_display_cont" style={Style}>
      {modal &&
        <ProductFileDisplayModal
          Data={Data}
          Type={Type}
          OnCloseModal={() => setModal(false)}
        />
      }
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
        isCover={true}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      {Data && Data.label &&  
        <div className="productfile_display_row_url" >
          {ShowDownload && Type == "pdf" &&
            <ActionButton
              IsDesktop={false}
              Label={getLabel("FileController", "Download")}
              Icon={MdDownload}
              OnClick={onDownload}
              buttonStyle={{ marginRight: "5px"}}
            />
          }
          <span onClick={onClickLink}>{Data.label[getLanguage().code] || Data.label["EN"] || ""} {"[" + Data.format + "]"}</span>
        </div>
      }
    </div>
  );

};

export default ProductFileDisplay